// A message body with its URLs rendered as real links (8 Sep 2026). The bubble is
// `white-space: pre-wrap`, so the plain segments keep the author's line breaks.
import { Fragment } from "react";
import { splitLinks } from "../../lib/links";

export function LinkedText({ text }: { text: string }) {
  return (
    <>
      {splitLinks(text).map((s, i) =>
        s.url ? (
          <a key={i} href={s.url} target="_blank" rel="noopener noreferrer">
            {s.text}
          </a>
        ) : (
          <Fragment key={i}>{s.text}</Fragment>
        ),
      )}
    </>
  );
}
